import { Component } from '@angular/core';

@Component({
  selector: 'app-info-mensaje',
  standalone: true,
  imports: [],
  templateUrl: './info-mensaje.component.html',
  styleUrl: './info-mensaje.component.scss'
})
export class InfoMensajeComponent {

}
